(() => {
  const cartAddUrl = () => window.routes?.cart_add_url || '/cart/add.js';

  function setButtonState(root, variant) {
    const form = root.querySelector('[data-leche-product-form]');
    const button = root.querySelector('[data-leche-add-button]');
    if (!form || !button || !variant) return;

    const id = form.querySelector('[name="id"]');
    if (id) id.value = variant.id;
    const available = Boolean(variant.available);
    button.disabled = !available;
    button.querySelector('[data-leche-button-label]').textContent = available
      ? button.dataset.label
      : (window.variantStrings?.soldOut || 'Sold out');
    button.querySelector('[data-leche-button-price]').textContent = ` — ${formatMoney(variant.price)}`;
  }

  function formatMoney(cents) {
    const amount = (Number(cents) / 100).toFixed(2);
    return `$${amount.replace(/\.00$/, '')}`;
  }

  function initVariants(root) {
    const selector = root.querySelector('[data-leche-variant-selector]');
    if (!selector || selector.dataset.initialized) return;
    selector.dataset.initialized = 'true';
    const variants = JSON.parse(selector.querySelector('[type="application/json"]').textContent);

    selector.addEventListener('change', async () => {
      const options = [...selector.querySelectorAll('fieldset')].map((fieldset) =>
        fieldset.querySelector('input:checked')?.value
      );
      const variant = variants.find((candidate) =>
        candidate.options.every((option, index) => option === options[index])
      );
      if (!variant) return;

      const sectionId = root.dataset.lecheSection;
      const url = new URL(root.dataset.productUrl, window.location.origin);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', `${url.pathname}${url.search}`);
      setButtonState(root, variant);

      const renderUrl = new URL(url);
      renderUrl.searchParams.set('section_id', sectionId);
      try {
        const response = await fetch(renderUrl);
        if (!response.ok) throw new Error(`Section refresh failed: ${response.status}`);
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const replacement = html.querySelector(`#LecheProduct-${sectionId}`);
        if (!replacement) throw new Error('Updated product section was not found');
        root.replaceWith(replacement);
        init(replacement);
      } catch (error) {
        console.error('Could not refresh product details for selected variant', error);
      }
    });
  }

  function initForm(root) {
    const form = root.querySelector('[data-leche-product-form]');
    if (!form || form.dataset.initialized) return;
    form.dataset.initialized = 'true';
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      const status = root.querySelector('[data-leche-form-status]');
      if (button.disabled) return;
      button.disabled = true;
      if (status) status.textContent = '';
      try {
        const selectedVariantId = form.querySelector('[name="id"]').value;
        // One customer action creates one line for the selected bundle SKU.
        // This explicitly prevents a companion 3-pack from being submitted.
        const items = [{id: selectedVariantId, quantity: 1}];
        const response = await fetch(cartAddUrl(), {
          method: 'POST',
          headers: {Accept: 'application/json', 'Content-Type': 'application/json'},
          body: JSON.stringify({items}),
        });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.description || payload.message || 'Could not add this item to your cart.');

        const cart = document.querySelector('cart-drawer');
        if (cart?.renderContents) {
          const drawer = await fetch('/?section_id=hd--global--cart-drawer');
          cart.renderContents(await drawer.text());
        }
        if (status) status.textContent = 'Added to cart.';
      } catch (error) {
        if (status) status.textContent = error.message || 'Could not add this item to your cart.';
      } finally {
        button.disabled = false;
      }
    });
  }

  function initDropdowns(root) {
    root.querySelectorAll('.component--product--dropdown__titles').forEach((trigger) => {
      if (trigger.dataset.lecheInitialized) return;
      trigger.dataset.lecheInitialized = 'true';
      trigger.addEventListener('click', () => {
        const active = trigger.classList.contains('component--product--dropdown__titles--active');
        root.querySelectorAll('.component--product--dropdown__titles').forEach((item) =>
          item.classList.remove('component--product--dropdown__titles--active')
        );
        if (!active) trigger.classList.add('component--product--dropdown__titles--active');
      });
    });
  }

  function initMedia(root) {
    const slider = root.querySelector('.component--product--media__slider');
    if (!slider || slider.dataset.lecheInitialized || !window.Splide) return;
    slider.dataset.lecheInitialized = 'true';
    new window.Splide(slider, {pagination: true, perPage: 1, gap: '8px', arrows: false}).mount();
  }

  function init(root) {
    if (!root) return;
    initVariants(root);
    initForm(root);
    initDropdowns(root);
    initMedia(root);
  }

  window.LecheProduct = {init};
  document.addEventListener('DOMContentLoaded', () =>
    document.querySelectorAll('[data-leche-product-detail]').forEach(init)
  );
})();
